import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c7d832"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flash-message-list" }
const _hoisted_2 = { class: "flash-check-icon icon" }
const _hoisted_3 = { class: "flash-alert-icon icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "slide-in-left" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flashMessages, (flashMessage) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "flash-message",
            role: "alert",
            key: flashMessage.id
          }, [
            _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [
              [_vShow, flashMessage.type === 'success']
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
              [_vShow, flashMessage.type === 'danger']
            ]),
            _createElementVNode("p", null, _toDisplayString(flashMessage.message), 1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}